module.exports = __webpack_public_path__ + "img/left-h.2bf49f0b.png";